import { request } from '@/shared/api';
import { withScopeQuery } from '@/shared/model/agent-scope';
export function fetchFixations(scope) {
    return request(withScopeQuery('/api/v1/fixations?limit=100', scope));
}
export function assignFixation(agentId, managerId) {
    return request('/api/v1/fixations', {
        method: 'POST',
        body: JSON.stringify({
            agentId,
            ...(managerId ? { managerId } : {}),
        }),
    });
}
export function releaseFixation(assignmentId) {
    return request(`/api/v1/fixations/${assignmentId}/release`, {
        method: 'POST',
        body: JSON.stringify({}),
    });
}
